import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'MR',
  text: 'Compré un sábado a la noche. El domingo ya tenía la lista de corte de la mesa rebatible lista. El lunes la fabriqué. El martes la instalé. El miércoles el cliente me mandó una foto con sus hijos comiendo en la mesa. Nunca más improvisar.',
  author: 'Marcelo R.',
  location: 'Buenos Aires',
  role: 'Carpintero Emprendedor'
}, {
  initials: 'JC',
  text: 'El Tomo 4 de la Cama Murphy es único en el mercado. Mis clientes no pueden creer que exista algo así a medida en Argentina. La primera que fabriqué la vendí en $1.100.000 ARS. El combo se pagó 55 veces solo.',
  author: 'Jorge C.',
  location: 'Rosario',
  role: 'Taller Propio'
}, {
  initials: 'SV',
  text: 'El Sistema Micro-Fábrica me cambió la forma de trabajar. El primer lote de 5 mesas me llevó el mismo tiempo que antes me llevaban 2. La semana siguiente tuve 3 clientes nuevos porque pude hacer entrega inmediata.',
  author: 'Sofía V.',
  location: 'Córdoba',
  role: 'Carpintera Independiente'
}, {
  initials: 'FL',
  text: 'El Bono 4 de scripts de venta es lo que más impacto tuvo en mi facturación. Antes enviaba el precio y silencio. Ahora envío el presupuesto en 3 niveles y el 70% elige el estándar o el premium. Subí mi ticket promedio un 45%.',
  author: 'Fernando L.',
  location: 'Tucumán',
  role: 'Carpintero y Vendedor'
}, {
  initials: 'LP',
  text: 'Mis presupuestos ahora se ven profesionales. El cliente siente que está comprando a una empresa, no a un carpintero de barrio. Eso me permitió cobrar un 35% más sin perder clientes. Al contrario, gané mejores clientes.',
  author: 'Laura P.',
  location: 'Mendoza',
  role: 'Taller de Muebles a Medida'
}, {
  initials: 'VT',
  text: "El Bono 6 de instalación segura me salvó de un reclamo enorme. Antes instalaba 'a ojo' el sistema de anclaje. Ahora tengo el protocolo completo y el cliente firma la hoja de instrucciones. Cero reclamos en 8 meses.",
  author: 'Valeria T.',
  location: 'Santa Fe',
  role: 'Carpintera con Taller Propio'
}, {
  initials: 'AR',
  text: 'El Tomo 3 de islas móviles es lo que nunca encontré en ningún lado. Fabricar una isla de cocina con ruedas y extensión rebatible lateral era algo que no sabía ni que existía. La primera la vendí en $420.000 ARS. El mercado está lleno de gente que la quiere.',
  author: 'Ariel R.',
  location: 'Salta',
  role: 'Carpintero Independiente'
}, {
  initials: 'RT',
  text: "Los planos del banco de trabajo plegable del Tomo 6 son los más detallados que vi. Instalé uno en mi propio departamento y ahora vendo el concepto de 'taller plegable urbano' a un nicho que nadie más está atendiendo.",
  author: 'Roberto T.',
  location: 'Neuquén',
  role: 'Maker y Carpintero'
}, {
  initials: 'CM',
  text: 'Fabriqué el primer set de 20 sillas para eventos con el Tomo 5. Las vendí a un salón de fiestas en $1.400.000 ARS. Ahora estoy negociando el segundo pedido. El combo me cambió el negocio por completo.',
  author: 'Carolina M.',
  location: 'Entre Ríos',
  role: 'Carpintera para Eventos'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 bg-cream" data-id="element-86">
      <div className="container mx-auto px-4" data-id="element-87">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-88">
          <h2 className="text-3xl md:text-5xl font-black text-wood-dark mb-4" data-id="element-89">
            Lo que dicen los carpinteros que ya lo usan:
          </h2>
          <p className="text-xl text-wood-medium italic" data-id="element-90">
            +500 carpinteros emprendedores de todo el país ya tienen su Super
            Combo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto" data-id="element-91">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index % 3 * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-warm border border-wood-light/10 flex flex-col h-full relative" data-id="element-92">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-wood-light/10" data-id="element-93" />
              <div className="flex mb-4" data-id="element-94">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-amber fill-amber" data-id="element-95" />)}
              </div>
              <p className="text-charcoal/80 italic mb-6 leading-relaxed flex-grow" data-id="element-96">
                "{testimonial.text}"
              </p>
              <div className="flex items-center mt-auto pt-4 border-t border-wood-light/10" data-id="element-97">
                <div className="bg-wood-dark text-amber w-10 h-10 rounded-full flex items-center justify-center font-serif font-bold mr-3 flex-shrink-0" data-id="element-98">
                  {testimonial.initials}
                </div>
                <div data-id="element-99">
                  <p className="font-bold text-wood-dark text-sm" data-id="element-100">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-charcoal/60" data-id="element-101">
                    {testimonial.location} | {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}